import { render } from "./StageProgress.vue?vue&type=template&id=1d6342a8&scoped=true"
import script from "./StageProgress.vue?vue&type=script&lang=js"
export * from "./StageProgress.vue?vue&type=script&lang=js"

import "./StageProgress.vue?vue&type=style&index=0&id=1d6342a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6342a8"]])

export default __exports__